import $ from 'jquery';
import mergeOptions from 'styleguide/lib/merge-options';
import { addToBagWithData } from "modules/add-to-bag";

const DEFAULTS = {};
const CONTAINER_CLASS = '.js-revieve-container';
const BUTTON_CLASS = '.js-revieve-try-on';

export const revieveTryOn = (options) => {
    const opts = mergeOptions(DEFAULTS, options, $(BUTTON_CLASS));

    try {
        if (opts.isPlp) {
            if (opts.checkAvailability) {
                let codes = [];
                $('li.js-plp-container').each((index, element) => {
                    const $element = $(element);
                    $element.attr('data-loader', 'tryOnLoader');
                });
                $('li.js-plp-container').Lazy({
                    tryOnLoader: function(element, response) {
                        const $element = $(element);
                        const code = $element.attr('id');
                        Revieve.API.liveAR.isTryOnAvailable({ product_id: code }, (available) => {
                            if (available) {
                                $element.find(CONTAINER_CLASS).removeClass('u-hide');
                                codes.push(code);
                            }
                        });
                    }
                }); 
                Revieve.API.liveAR.loadTryOnProducts(codes);
            }
        } else {
            Revieve.API.liveAR.isTryOnAvailable({ product_id: opts.code }, (available) => {
                if (available) {
                    $(CONTAINER_CLASS).removeClass('u-hide');
                }
            });
        }
    } catch (ignored) { }

    setEventListeners();
}

export const revieveAddToBag = () => {
    $(window).on('revieveAddToBag', (e, data) => {
        data.products.forEach((product) => {
            addToBagWithData({
                colorSelect: product.id,
                sizeSelect: 'all',
                count: 1,
                sectionURL: data.sectionUrl,
                csrfHash: data.csrfHash,
            }, {
                success: (obj) => {
                    // start GA add to cart
                    gaAddToCartActionProduct('add', {
                        code: '' + product.id + '',
                        name: product.name,
                        category: obj.msg16,
                        brand: obj.msg3,
                        variant: 'all',
                        price: obj.msg15,
                        quantity: 1
                    });
                    // end GA add to cart

                    if (pushAddProductToCordial === 'function') {
                        pushAddProductToCordial(product.name,
                            product.id,
                            obj.msg15,
                            obj.msg3,
                            obj.msg16,
                            null,
                            obj.msg28,
                            1,
                            obj.msg29,
                            obj.msg30);
                    }

                    if (insertFacebookAddToCart === 'function') {
                        insertFacebookAddToCart(null, product.id, obj.msg15, 'all');
                    }

                    if (typeof addToCartPinterest === 'function') {
                        addToCartPinterest(product.id, obj.msg15, 1);
                    }

                    if (typeof addToCartReddit === 'function') {
                        const cartItems = [{
                            productCode: product.id,
                            productName: product.name,
                            productCategory: obj.msg16
                        }];
                        addToCartReddit(cartItems, obj.msg15, product.id, product.name, obj.msg16);
                    }
                    if (typeof spanglePixelAddToCart === 'function') {
                        spanglePixelAddToCart(product.id, obj.msg15, 1);
                    }
                }
            });
        });
    });
}

function setEventListeners() {
    $(document).on('click', BUTTON_CLASS, (e) => {
        e.preventDefault();
        Revieve.API.liveAR.addTryOnProduct($(e.target).data('code'));
        Revieve.API.show();
        // VTO stands for Virtual Try On
        logEngagement(window.location.href, 'VTO', 'Open');
    });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/revieve-try-on.js